export const HIGO_CAPITAL_RFC = 'HCA210715U67';
export const HIGO_CAPITAL_TAXPAYERNAME = 'Higo Capital SA de CV';
